<template>
  <FormSection title="Passwort">
    <template #text>
      Ändere das Passwort, das du für den Login verwendest.
    </template>
    <template #form>
      <PasswordForm :resource="resource" :errors="errors" />
    </template>
  </FormSection>
  <FormButtons>
    <SubmitButton @click="onSubmit" :load="updating">
      Speichern
    </SubmitButton>
  </FormButtons>
</template>


<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { useUpdateResource } from '@/client/actions';

const store = useStore();

const target = computed(() => '/api/account/password');
const resource = ref(new Object);
const action = useUpdateResource(target, resource);

const { errors, message, updating, update } = action;

const onSuccess = () => store.dispatch('auth/reload');
const onSubmit = () => update(onSuccess);
</script>
